import LazyLoad from "vanilla-lazyload"

/* global Swiper */
// eslint-disable-next-line no-new
new LazyLoad({
  elements_selector: "[data-about-slider]",
  callback_enter: (e) => {
    // eslint-disable-next-line no-new
    new Swiper(e, {
      preloadImages: false,
      lazy: true,
      grabCursor: true,
      loop: true,
      navigation: {
        nextEl: ".about__slider-btn--next",
        prevEl: ".about__slider-btn--prev",
      },
    })
  },
})



// WEBPACK FOOTER //
// ./src/blocks/03.about/about.js